import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { IonDatetime } from '@ionic/angular';
import * as moment from 'moment';

@Component({
  selector: 'app-date-time-picker',
  templateUrl: './date-time-picker.component.html',
  styleUrls: ['./date-time-picker.component.scss'],
  standalone: false
})
export class DateTimePickerComponent implements OnInit {

  @ViewChild(IonDatetime) datetime: IonDatetime;
  @Input() type = 'date';
  @Input() contenerType = 'date';
  @Input() min: any;
  @Input() max: any;
  @Input() date_format: any;
  @Input() date_info: any;
  @Input() isDisabled: boolean = false;
  @Input() value: any;
  @Output() datePickerValue: EventEmitter<any> = new EventEmitter<any>();
  dateValue = '';
  today: any;
  dateSelected: any;
  preDefineDate: any;

  constructor() { }

  ngOnInit() {
    // this.max = this.getCurrentDate();
    // Added condition to get defined date value from order component

    if (this.value === undefined) {
      this.value = this.getCurrentDate();
    }
    if (this.value !== undefined) {
      this.preDefineDate = this.value;
    }
    this.dateSelected = 0;
    this.today = this.getCurrentDate();
  }

  getCurrentDate(format: string = 'YYYY-MM-DD') {
    if (this.date_format) {
      return moment().format(this.date_format);
    } else {
      return moment().format(format);
    }
  }

  change(value, type) {
    this.dateSelected = 1;
  }

  cancel() {
    this.datetime.cancel(true);
  }

  done(value: any, type: any) {
    this.datePickerValue.emit({ "value": value, "type": type });
    this.datetime.confirm(true);
  }
}
